import { CFormText } from "@coreui/react";
import React from "react";

export function ErrorList({ errors }) {
  if (errors && typeof errors == "object") {
    return Object.keys(errors).map((key) => {
      if (Array.isArray(errors[key])) {
        return (
          <CFormText className="help-block" key={key}>
            {"* " + key + " " + errors[key][0]}
          </CFormText>
        );
      }
      return "";
    });
  }

  if (typeof errors === "string") {
    return <CFormText className="help-block">{errors}</CFormText>;
  }
  return null;
}
